export const isInIntakeQueue = (item, view = 'pending') => {
  if (item.archived || item.archivedAt) return false;
  const accepted = String(item.status).toLowerCase() === 'accepted';
  return view === 'all' || (view === 'accepted' ? accepted : !accepted);
};

// The existing API has an exact-status filter, not a pending-status group.
// Look ahead through a bounded number of pages; retain the real server cursor
// when the limit is reached, so an empty window never means an empty account.
export const createIntakeQueueReader = list => async ({ queueView, ...query }) => {
  if (!queueView || queueView === 'all') return list(query);
  if (queueView === 'accepted') return list({ ...query, status: 'accepted', includeArchived: false });
  const items = [], cursors = new Set(query.cursor ? [query.cursor] : []);
  const limit = query.limit || 25;
  let cursor = query.cursor, result;
  for (let page = 0; page < 3; page += 1) {
    result = await list({ ...query, cursor, limit: limit - items.length, includeArchived: false });
    if (!result?.ok) return result;
    const data = result.data;
    if (!data || !Array.isArray(data.items) || typeof data.hasMore !== 'boolean'
      || data.items.length > limit - items.length
      || (data.hasMore && (!data.nextCursor || cursors.has(data.nextCursor)))) {
      return { ok: false, error: 'The document queue could not be read. Please retry.' };
    }
    items.push(...data.items.filter(item => isInIntakeQueue(item, 'pending')));
    if (!data.hasMore || items.length >= limit) break;
    cursor = data.nextCursor; cursors.add(cursor);
  }
  return { ...result, data: { ...result.data, items } };
};
